// extracted by mini-css-extract-plugin
module.exports = {"root":"HiddenVisually-module__root___cq4PV"};